import React from "react";
import { X, Loader2 } from "lucide-react";

export default function DispatchShipmentModal({
  isOpen,
  onClose,
  formData,
  setFormData,
  carriers,
  statuses,
  loading,
  onSubmit
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Dispatch Cargo Shipment</h3>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <form onSubmit={onSubmit}>
          <div className="grid-2" style={{ gap: "1rem", gridTemplateColumns: "1fr 1fr" }}>
            <div className="form-group">
              <label className="form-label" htmlFor="trackingNumber">Tracking Number</label>
              <input
                id="trackingNumber"
                type="text"
                required
                className="form-input"
                value={formData.trackingNumber}
                onChange={(e) => setFormData({ ...formData, trackingNumber: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="carrier">Carrier</label>
              <select
                id="carrier"
                className="form-input"
                value={formData.carrier}
                onChange={(e) => setFormData({ ...formData, carrier: e.target.value })}
              >
                {carriers.map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="origin">Origin Facility / Address</label>
            <input
              id="origin"
              type="text"
              required
              className="form-input"
              placeholder="e.g. Shanghai Port, CN"
              value={formData.origin}
              onChange={(e) => setFormData({ ...formData, origin: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="destination">Final Destination</label>
            <input
              id="destination"
              type="text"
              required
              className="form-input"
              placeholder="e.g. Los Angeles Warehouse A"
              value={formData.destination}
              onChange={(e) => setFormData({ ...formData, destination: e.target.value })}
            />
          </div>

          <div className="grid-2" style={{ gap: "1rem", gridTemplateColumns: "1.2fr 0.8fr" }}>
            <div className="form-group">
              <label className="form-label" htmlFor="estimatedDelivery">Estimated Delivery (ETA)</label>
              <input
                id="estimatedDelivery"
                type="date"
                required
                className="form-input"
                value={formData.estimatedDelivery}
                onChange={(e) => setFormData({ ...formData, estimatedDelivery: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="status">Initial Status</label>
              <select
                id="status"
                className="form-input"
                value={formData.status}
                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              >
                {statuses.slice(0, 2).map(st => (
                  <option key={st} value={st}>{st}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="logistics-modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? <Loader2 className="logistics-spinner" size={16} /> : null}
              Dispatch
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
